
import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../../react-app-env';

const _editLabUserInitQuery = (lab_id: string, user_id: string) => ({
  labs_by_pk: params(
    { id: rawString(lab_id) },
    {
      name: types.string,
    },
  ),
  users_receiver_by_pk: params(
    { id: rawString(user_id) },
    {
      id: types.string,
      first_name: types.string,
      last_name: types.string,
      full_name: types.string,
      email: types.string,
      hcpc_number: types.string,
      dob: types.string,
      gender: types.string,
      receiver_type: types.string,
      labs: [{
        id: types.string,
        lab: {
          id: types.string,
          name: types.string,
        },
      }],
      enum_receiver_type: {
        receiver_type: types.string,
        description: types.string,
      },
    },
  ),
  labs: params(
    { order_by: { name: 'asc' }},
    [{
      id: types.string,
      name: types.string,
    }],
  ),
  enum_receiver_types: [{
  	receiver_type: types.string,
    description: types.string,
  }],
});

type X = Unpacked<typeof _editLabUserInitQuery>
export type ReceiverUser = X['users_receiver_by_pk'];
export type LabAssignment = ReceiverUser['labs'][0];
export type Lab = X['labs'][0];
export type EnumReceiverType = X['enum_receiver_types'][0];

export const editLabUserInitQuery = (lab_id: string, user_id: string) => gql`${query(_editLabUserInitQuery(lab_id, user_id))}`;
